import { isArray } from '../../utils/customMethods'

const initialStatus = {
  loading: false,
  success: false,
  error: false,
  data: null,
  message: null,
}

const initialState = { conversations: {} }

const insightReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'RESET_INSIGHTS_OBJ':
      return {}

    // TODO: check if it's better to clean or delete status
    case 'RESET_INSIGHTS_STATUS':
      return {
        ...state,
        status: {
          ...state.status,
          [action.payload]: initialStatus,
        },
      }
    case 'INSIGHTS_ERROR':
      return {
        ...state,
        status: {
          ...state?.status,
          [action?.payload?.action]: {
            ...initialStatus,
            error: true,
            message: action?.payload?.message,
          },
        },
      }
    case 'GET_INSIGHTS':
      return {
        ...state,
        status: {
          get_insights: {
            ...initialStatus,
            loading: true,
            data: { ...action.payload },
          },
        },
      }
    case 'SET_INSIGHTS':
      return {
        ...state,
        conversations: {
          ...state.conversations,
          [action.payload.chatId]: { ...action.payload.data },
        },
        status: {
          ...state.status,
          get_insights: {
            ...initialStatus,
            success: true,
          },
        },
      }
    case 'SEND_INSIGHTS':
      return {
        ...state,
        status: {
          ...state.status,
          send_insights: {
            ...initialStatus,
            loading: true,
            data: { ...action.payload },
          },
        },
      }
    case 'SET_INSIGHT': {
      const chatId = action.payload.chatId
      const newInsights = action.payload.data
      const insights = (chatId && state.conversations?.[chatId]) ?? {}
      const value = insights?.[newInsights?.cat]?.some(
        (el) => el === newInsights?.value
      )
        ? []
        : [newInsights?.value]

      return {
        ...state,
        conversations: {
          ...state.conversations,
          [chatId]: {
            ...insights,
            [newInsights?.cat]: [
              ...(insights?.[newInsights?.cat] ?? []),
              ...value,
            ],
          },
        },
        status: {
          ...state.status,
          set_insight: {
            ...initialStatus,
            success: true,
          },
        },
      }
    }

    default:
      return state
  }
}

export default insightReducer
